import { Link } from '@tanstack/react-router';
import { Button, Pill, TableCell, TableRow } from '@/shared/components';
import type { OnboardingLinkAdminResponse, OnboardingLinkStatus } from '@/shared/api';
import { formatDateTime } from '@/shared/lib/format';
import { onboardingStatusLabel } from './systemLabels';

const statusVariants: Record<OnboardingLinkStatus, 'accent' | 'warning' | 'error' | 'outline'> = {
  Active: 'outline',
  Sent: 'accent',
  Used: 'accent',
  Expired: 'error',
};

interface Props {
  link: OnboardingLinkAdminResponse;
  retrying: boolean;
  onReIssue: () => void;
}

export function GuestEmailRow({ link, retrying, onReIssue }: Props) {
  return (
    <TableRow>
      <TableCell>
        <Pill variant={statusVariants[link.status]} size="sm">
          {onboardingStatusLabel(link.status)}
        </Pill>
      </TableCell>
      <TableCell className="font-mono text-xs">
        <Link
          to="/bookings/$id"
          params={{ id: link.bookingId }}
          className="text-ink underline-offset-4 hover:underline"
        >
          {link.bookingId.slice(0, 8)}…
        </Link>
      </TableCell>
      <TableCell className="whitespace-nowrap font-mono text-xs">
        {formatDateTime(link.expiresAt)}
      </TableCell>
      <TableCell className="text-ink-soft text-xs">
        {link.emailSent
          ? `Verschickt am ${formatDateTime(link.emailSentAt ?? '')}`
          : 'Noch nicht verschickt'}
      </TableCell>
      <TableCell className="text-right tabular-nums">
        {link.useCount}
        {link.lastUsedAt && (
          <span className="text-ink-faint ml-1 text-xs">
            (zuletzt {formatDateTime(link.lastUsedAt)})
          </span>
        )}
      </TableCell>
      <TableCell className="text-right">
        <Button variant="ghost" className="min-h-11" loading={retrying} onClick={onReIssue}>
          E-Mail erneut senden
        </Button>
      </TableCell>
    </TableRow>
  );
}
